import React from "react"
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux"
import classes from "./OrderStatusFilter.module.scss"
import {setOrderFilters} from "../../../../../store/actions/orderActions"

interface OrderStatusFilterProps {
  className?: string
}

function OrderStatusFilter({className}: OrderStatusFilterProps) {

  const {statuses, filters} = useAppSelector(state => state.order)
  const dispatch = useAppDispatch()

  const statusTabs = [
    {
      name: "Все заявки",
      status: 0,
      selected: true
    }
  ]

  statuses.length && statuses.forEach(status => {
    statusTabs.push({
      name: status.name,
      status: status.id,
      selected: false
    })
  })

  const clickHandler = (id: number) => {
    dispatch(setOrderFilters({...filters, status_id: id}))
  }

  const cls = [classes.wrap, "styled-scroll"]

  if (className)
    cls.push(className)

  const statusTabsTemplate = statusTabs.map(tab => {

    const selected = (filters.status_id === tab.status) || (!filters.status_id && tab.status === 0)

    return (
      <div className={[classes.item, selected && classes.item_selected].join(" ")} key={tab.status} onClick={() => clickHandler(tab.status)}>
        <div className={classes.name}>{tab.name}</div>
      </div>
    )
})

  return (
    <div className={cls.join(" ")}>
      {statusTabsTemplate}
    </div>
  )
}

export default OrderStatusFilter